<template>
  <div>
    <product-list-add-new
      :is-add-new-product-sidebar-active.sync="isAddNewProductSidebarActive"
      :data="productData"
      :category-options="categoryOptions"
      @refetch-data="refetchData"
    />

    <b-card no-body v-if="user_id == 1">
      <b-card-header class="pb-50">
        <h5>Filter</h5>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col cols="12" md="3" class="mb-md-0 mb-2">
            <label>Company</label>
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="userOptions"
              label="name"
              class="w-100"
              :reduce="(val) => val.id"
              v-model="userFilter"
            />
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card no-body class="mb-0">
      <div class="m-2 list-wrapper">
        <!-- Table Top -->
        <div
          class="d-flex flex-wrap flex-lg-nowrap align-items-center justify-content-between"
        >
          <div class="d-flex flex-wrap flex-lg-nowrap align-items-center">
            <h3 class="font-weight-bolder text-nowrap mb-0">
              <feather-icon size="18" icon="MonitorIcon" />
              Product
            </h3>
            <div class="form-col-select ml-2">
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block"
              />
              <feather-icon size="18" icon="ChevronDownIcon" />
            </div>
          </div>
          <div class="row m-0 flex-lg-nowrap">
            <div class="search-primary mr-2">
              <feather-icon size="16" icon="SearchIcon" />
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
            </div>
            <div class="">
              <b-button
               variant="primary"
                v-if="ability.can('create', 'product') || true"
                class="mobile-w100 mt-2 mt-sm-0"
                @click="handleCreate"
              >
                <span class="text-nowrap">Add Product</span>
              </b-button>
            </div>
            <div class="ml-2">
              <b-button
               variant="primary"
                v-if="ability.can('create', 'users') || true"
                class="mobile-w100 mt-2 mt-sm-0"
                :to="{ name: 'hktv-edit'}">

                <span class="text-nowrap">Add HKTV Mall Product</span>
              </b-button>
            </div>

            <div class="ml-2">
              <b-button
               variant="primary"
                v-if="ability.can('read', 'users')"
                class="mobile-w100 mt-2 mt-sm-0"
                :to="{ name: 'hktv-category'}">

                <span class="text-nowrap">HKTV Category</span>
              </b-button>
            </div>
          </div>
        </div>
      </div>

      <b-overlay :show="loading" rounded="sm">
        <b-table
          ref="refProductListTable"
          class="position-relative wrapper2"
          :items="fetchProducts"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="No matching records found"
          :sort-desc.sync="isSortDirDesc"
        >
          <template #cell(image)="data">
            <b-col v-if="data.item.image_url == null"> NO IMAGE </b-col>

            <b-col v-else md="2">
              <el-image :src="data.item.image_url" />
            </b-col>
          </template>

          <template #cell(description)="data">
            <div v-html="data.item.description"></div>
          </template>

          <template #cell(meta_description)="data">
            <div v-html="data.item.meta_description"></div>
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <b-dropdown
              :class="`action-trigger-btn ${
                productList.length <= 3 ? 'hor' : 'ver'
              }`"
              variant="link"
              no-caret
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>

              <b-dropdown-item
                v-if="ability.can('update', 'product') || true"
                @click="handleUpdate(data.item)"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">Edit</span>
              </b-dropdown-item>

              <b-dropdown-item
                v-if="ability.can('delete', 'product') || true"
                @click="removeItem(data.item.id)"
              >
                <feather-icon icon="Trash2Icon" />
                <span class="align-middle ml-50">Delete</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
      </b-overlay>

      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >Showing {{ dataMeta.from }} to {{ dataMeta.to }} of
              {{ dataMeta.of }} entries</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRow"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BOverlay,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import useProductsList from "./useProductsList";
import productListAddNew from "./productListAddNew";
import productStoreModule from "../productStoreModule";
import { getUserData } from "@/auth/utils";
import router from "@/router";
import Ripple from "vue-ripple-directive";

export default {
  data() {
    return {
      loading: false,
      isAddNewProductSidebarActive: false,
      productData: {},
    };
  },
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    vSelect,
    BOverlay,
    productListAddNew,
  },
  computed: {
    user_id() {
      return getUserData().id;
    },
  },
  methods: {
    handleUpdate(item) {
      this.productData = item;
      this.isAddNewProductSidebarActive = true;
    },
    handleCreate() {
      this.productData = {
        id: 0,
        model: "",
        sku: "",
        mpn: "",
        price: 0,
        name: "",
        description: "",
        short_description: "",
        meta_title: "",
        meta_description: "",
        meta_keyword: "",
        category_id: null
      };
      this.isAddNewProductSidebarActive = true;
    },
    removeItem(id) {
      // check number of record
      this.$swal({
        title: "Are you sure?",
        text: "Your action is final and you will not be able to retrieve this product.",
        showCancelButton: true,
        confirmButtonText: "Delete",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch(`app-product/deleteProduct`, { id })
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = "app-product";
    const env = process.env.VUE_APP_IMAGE_URL;

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, productStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    const {
      fetchProducts,
      tableColumns,
      perPage,
      currentPage,
      totalRow,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refProductListTable,
      ability,
      refetchData,
      productList,
      userOptions,
      userFilter,
      categoryOptions
    } = useProductsList();

    return {
      fetchProducts,
      tableColumns,
      perPage,
      currentPage,
      totalRow,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refProductListTable,
      ability,
      env,
      refetchData,
      productList,
      userOptions,
      userFilter,
      categoryOptions
    };
  },
};
</script>

<style lang="scss" scoped></style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.wrapper1 {
  width: 100%;
}
.wrapper1 {
  overflow-x: scroll;
  div {
    height: 1px;
  }
}
.el-image {
  width: 240px;
  aspect-ratio: 16 / 14;
}
</style>
